<template>
    <div>
        <v-slide-x-reverse-transition>
            <v-alert type="success" class="alert_success"
                v-if="alert_show_add === true">บันทึกบัญชีประจำวันเรียบร้อย</v-alert>
            <v-alert type="success" class="alert_success"
                v-if="alert_show_edit === true">แก้ไขบันทึกบัญชีประจำวันเรียบร้อย</v-alert>
        </v-slide-x-reverse-transition>
        <div class="mb-2">
            <v-tabs grow>
                <v-tab @click="page(1)">บันทึกบัญชีประจำวัน</v-tab>
                <v-tab @click="page(2)">รายได้ค้างรับ</v-tab>
            </v-tabs>
        </div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-if="loading_page === false">
            <!-- บันทึกบัญชีประจำวัน -->
            <div v-if="page_number == 1">
                <div class="mb-2">
                    <h2>บันทึกบัญชีประจำวัน</h2>
                </div>
                <div class="inout_account_day_list mb-2">
                    <div class="mr-1">
                        <v-btn class="pa-3" color="success" width="100%" height="auto" @click="openIncome()">
                            <div class="d-flex justify-center align-center flex-column ">
                                <div class="img_inout_account_day_list">
                                    <img src="@/assets/profits.png">
                                </div>
                                <div>เงินเข้า</div>
                            </div>
                        </v-btn>
                    </div>
                    <div class="ml-1">
                        <v-btn class="pa-3" color="error" width="100%" height="auto" @click="openOutcome()">
                            <div class="d-flex justify-center align-center flex-column ">
                                <div class="img_inout_account_day_list">
                                    <img src="@/assets/calculator.png">
                                </div>
                                <div>เงินออก</div>
                            </div>
                        </v-btn>
                    </div>
                </div>
                <v-card>
                    <h3 class="pt-4 px-4 text-right">คงเหลือทั้งหมด {{ balance_all }} บาท</h3>
                    <v-card-title>
                        <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search"
                            single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="data" :search="search" :sort-by.sync="sortIncomeBy"
                        :sort-desc.sync="sortIncomeDesc">
                        <template v-slot:item="dataDetail">
                            <tr>
                                <td>{{ dataDetail.item.date_create }}</td>
                                <td>
                                    <span>
                                        {{ dataDetail.item.ac_name }}
                                    </span>
                                    <v-tooltip bottom color="warning" v-if="dataDetail.item.status_edit">
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on">
                                                <v-icon color="grey">mdi-message-alert</v-icon>
                                            </span>
                                        </template>
                                        <div>
                                            เหตุผลในการแก้ไข : {{ dataDetail.item.description_update }}
                                        </div>
                                        <div>
                                            โดย : {{ dataDetail.item.user_update }}
                                        </div>
                                    </v-tooltip>
                                </td>
                                <td>{{ dataDetail.item.ac_type }}</td>
                                <td class="success--text">
                                    <div v-if="dataDetail.item.price_income != '-'">
                                        <div v-if="!dataDetail.item.description">
                                            {{ dataDetail.item.price_income }}
                                        </div>
                                        <v-tooltip bottom color="success" v-else>
                                            <template v-slot:activator="{ on, attrs }">
                                                <div v-bind="attrs" v-on="on">
                                                    {{ dataDetail.item.price_income }}
                                                </div>
                                            </template>
                                            <span>{{ dataDetail.item.description }}</span>
                                        </v-tooltip>
                                    </div>
                                    <div v-else>
                                        {{ dataDetail.item.price_income }}
                                    </div>
                                </td>
                                <td class="error--text">
                                    <div v-if="dataDetail.item.price_expenses != '-'">
                                        <div v-if="!dataDetail.item.description">
                                            {{ dataDetail.item.price_expenses }}
                                        </div>
                                        <v-tooltip bottom color="error" v-else>
                                            <template v-slot:activator="{ on, attrs }">
                                                <div v-bind="attrs" v-on="on">
                                                    {{ dataDetail.item.price_expenses }}
                                                </div>
                                            </template>
                                            <span>{{ dataDetail.item.description }}</span>
                                        </v-tooltip>
                                    </div>
                                    <div v-else>
                                        {{ dataDetail.item.price_expenses }}
                                    </div>
                                </td>
                                <td>{{ dataDetail.item.balance }}</td>
                                <td>
                                    <span class="cursor_open_title_in_account_day_list"
                                        @click="detailAccountBook(dataDetail.item.id, dataDetail.item.type)">
                                        <v-icon right color="grey">mdi-pencil-box-outline</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <div class="pa-3">
                        <v-btn width="100%" height="50"
                            @click="$router.push('/accountretrospect')">ดูรายการบัญชีย้อนหลัง</v-btn>
                    </div>
                </v-card>
            </div>
            <!-- รายได้ค้างรับ -->
            <div v-if="page_number == 2">
                <div class="mb-2">
                    <h2>รายได้ค้างรับ</h2>
                </div>
                <!-- <div class="mb-2">
                <v-btn class="pa-3" color="success" width="100%" height="auto" @click="openIncome(2)">
                    <div class="d-flex justify-center align-center flex-column ">
                        <div class="img_inout_account_day_list">
                            <img src="@/assets/profits.png">
                        </div>
                        <div>เพิ่มรายการรายได้ค้างรับ</div>
                    </div>
                </v-btn>
            </div> -->
                <v-card>
                    <h3 class="pt-4 px-4 text-right">คงเหลือทั้งหมด {{ balance_all }} บาท</h3>
                    <v-card-title>
                        <v-text-field v-model="search" color="warning" append-icon="mdi-magnify" label="Search"
                            single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers_accrued" :items="data" :search="search_accrued"
                        :sort-by.sync="sortBy_accrued" :sort-desc.sync="sortDesc_accrued">
                        <template v-slot:item="dataDetail">
                            <tr>
                                <td>{{ dataDetail.item.date_create }}</td>
                                <td>
                                    <span>
                                        {{ dataDetail.item.ac_name }}
                                    </span>
                                    <v-tooltip bottom color="warning" v-if="dataDetail.item.status_edit">
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on">
                                                <v-icon color="grey">mdi-message-alert</v-icon>
                                            </span>
                                        </template>
                                        <div>
                                            เหตุผลในการแก้ไข : {{ dataDetail.item.description_update }}
                                        </div>
                                        <div>
                                            โดย : {{ dataDetail.item.user_update }}
                                        </div>
                                    </v-tooltip>

                                </td>
                                <td>{{ dataDetail.item.ac_type }}</td>
                                <td class="success--text">
                                    <div v-if="dataDetail.item.price_income != '-'">
                                        <div v-if="!dataDetail.item.description">
                                            {{ dataDetail.item.price_income }}
                                        </div>
                                        <v-tooltip bottom color="success" v-else>
                                            <template v-slot:activator="{ on, attrs }">
                                                <div v-bind="attrs" v-on="on">
                                                    {{ dataDetail.item.price_income }}
                                                </div>
                                            </template>
                                            <span>{{ dataDetail.item.description }}</span>
                                        </v-tooltip>
                                    </div>
                                    <div v-else>
                                        {{ dataDetail.item.price_income }}
                                    </div>
                                </td>
                                <!-- <td>
                                <span class="cursor_open_title_in_account_day_list" @click="detailAccountBook(dataDetail.item.id,dataDetail.item.type,2)">
                                    <v-icon right color="grey">mdi-pencil-box-outline</v-icon>
                                </span>
                            </td> -->
                            </tr>
                        </template>
                    </v-data-table>
                    <div class="pa-3">
                        <v-btn width="100%" height="50"
                            @click="$router.push('/accruedincome')">ดูรายได้ค้างรับย้อนหลัง</v-btn>
                    </div>
                </v-card>
            </div>
            <v-dialog v-model="open_income" persistent max-width="600px">
                <div v-if="loading_detail_page === true">
                    <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                    </v-sheet>
                </div>
                <v-card v-if="loading_detail_page === false">
                    <v-card-title class="title_open_title_in_account_day_list justify-space-between">
                        <div>
                            บันทึกเงินเข้า
                        </div>
                        <div class="cursor_open_title_in_account_day_list" @click="open_income = false">
                            <v-icon color="white">mdi-close</v-icon>
                        </div>
                    </v-card-title>
                    <v-form ref="form_income" @submit.prevent="addIncome()">
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <v-menu ref="menu_open_date_in" v-model="menu_open_date_in"
                                            :close-on-content-click="false" :return-value.sync="account_date_in"
                                            transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="account_date_in_be" label="วันที่ (วัน/เดือน/ปี)"
                                                    readonly v-bind="attrs" v-on="on"
                                                    :rules="[v => !!v || 'กรุณากรอกวันที่เริ่ม']" required
                                                    outlined></v-text-field>
                                            </template>
                                            <v-date-picker v-model="account_date_in" :max="max_date" no-title scrollable
                                                locale="th" :events="dateStartEndBE('date_in')">
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="searchDate('date_in')">
                                                    ตกลง
                                                </v-btn>
                                                <v-btn text color="primary" @click="menu_open_date_in = false">
                                                    ยกเลิก
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                        <v-select label="ประเภทบัญชี" :items="account_type_in" @change="accountTypeIn"
                                            item-text="ac_type_name" item-value="id" v-model="account_input.ac_type_id"
                                            :rules="[v => !!v || 'กรุณาเลือกประเภทบัญชี']" required outlined>
                                        </v-select>
                                        <v-select label="รายชื่อเจ้าหนี้" v-if="creditor === 1"
                                            :items="account_creditor" item-text="creditor_name" item-value="id"
                                            v-model="account_input_creditor"
                                            :rules="[v => !!v || 'กรุณาเลือกรายชื่อเจ้าหนี้']" required outlined>
                                        </v-select>
                                        <v-select label="รายชื่อผู้ลงทุน" v-if="capital === 1" :items="account_capital"
                                            item-text="capital_name" item-value="id" v-model="account_input_capital"
                                            :rules="[v => !!v || 'กรุณาเลือกรายชื่อผู้ลงทุน']" required outlined>
                                        </v-select>
                                        <v-select label="รายชื่อเดลิเวอรี่" v-if="delivery === 1"
                                            @change="accountDateDelivery" :items="account_delivery"
                                            item-text="debtor_name" item-value="id" v-model="account_input_delivery"
                                            :rules="[v => !!v || 'กรุณาเลือกรายชื่อเดลิเวอรี่']" required outlined>
                                        </v-select>
                                        <v-select label="วันที่เดลิเวอรี่"
                                            v-if="account_input_delivery && status_accrued_income == 1"
                                            :items="account_date_delivery" item-text="date_create"
                                            item-value="account_books_id" v-model="account_input_date_delivery"
                                            :rules="[v => !!v || 'กรุณาเลือกรายชื่อเดลิเวอรี่']" required outlined>
                                        </v-select>
                                        <v-text-field label="ชื่อรายการ"
                                            v-if="creditor === 0 && capital === 0 && delivery === 0"
                                            v-model="account_input.ac_name" :rules="[v => !!v || 'กรุณากรอกชื่อรายการ']"
                                            required outlined></v-text-field>
                                        <v-text-field label="จำนวน (บาท)" type="number" v-model="account_input.price"
                                            :rules="[v => !!v || 'กรุณากรอกจำนวน']" required outlined></v-text-field>
                                        <v-textarea name="input-7-1" label="รายละเอียด"
                                            v-model="account_input.description" outlined>
                                            {{ account_input.description }}
                                        </v-textarea>
                                    </v-col>

                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                            <v-btn color="#28ab28" class="white--text" height="50" width="50%" type="submit">
                                บันทึก
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
            <v-dialog v-model="open_outcome" persistent max-width="600px">
                <div v-if="loading_detail_page === true">
                    <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                    </v-sheet>
                </div>
                <v-card v-if="loading_detail_page === false">
                    <v-card-title class="title_open_title_out_account_day_list justify-space-between">
                        <div>
                            บันทึกเงินออก
                        </div>
                        <div class="cursor_open_title_in_account_day_list" @click="open_outcome = false">
                            <v-icon color="white">mdi-close</v-icon>
                        </div>
                    </v-card-title>
                    <v-form ref="form_outcome" @submit.prevent="addOutcome()">
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <v-menu ref="menu_open_date_out" v-model="menu_open_date_out"
                                            :close-on-content-click="false" :return-value.sync="account_date_out"
                                            transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="account_date_out_be"
                                                    label="วันที่เริ่ม (วัน/เดือน/ปี)" readonly v-bind="attrs" v-on="on"
                                                    :rules="[v => !!v || 'กรุณากรอกวันที่เริ่ม']" required
                                                    outlined></v-text-field>
                                            </template>
                                            <v-date-picker v-model="account_date_out" :max="max_date" no-title
                                                scrollable locale="th" :events="dateStartEndBE('date_out')">
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="searchDate('date_out')">
                                                    ตกลง
                                                </v-btn>
                                                <v-btn text color="primary" @click="menu_open_date_out = false">
                                                    ยกเลิก
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                        <v-select label="ประเภทบัญชี" :items="account_type_out" @change="accountTypeOut"
                                            item-text="ac_type_name" item-value="id" v-model="account_input.ac_type_id"
                                            :rules="[v => !!v || 'กรุณาเลือกประเภทบัญชี']" required outlined>
                                        </v-select>
                                        <v-select label="รายชื่อเจ้าหนี้" v-if="creditor === 1"
                                            :items="account_creditor" item-text="creditor_name" item-value="id"
                                            v-model="account_input_creditor"
                                            :rules="[v => !!v || 'กรุณาเลือกรายชื่อเจ้าหนี้']" required outlined>
                                        </v-select>
                                        <v-select label="รายชื่อผู้ลงทุน" v-if="capital === 1" :items="account_capital"
                                            item-text="capital_name" item-value="id" v-model="account_input_capital"
                                            :rules="[v => !!v || 'กรุณาเลือกรายชื่อผู้ลงทุน']" required outlined>
                                        </v-select>
                                        <v-select label="รายชื่อเดลิเวอรี่" v-if="delivery === 1"
                                            @change="accountDateDelivery" :items="account_delivery"
                                            item-text="debtor_name" item-value="id" v-model="account_input_delivery"
                                            :rules="[v => !!v || 'กรุณาเลือกรายชื่อเดลิเวอรี่']" required outlined>
                                        </v-select>
                                        <v-text-field label="ชื่อรายการ" v-model="account_input.ac_name"
                                            :rules="[v => !!v || 'กรุณากรอกชื่อรายการ']" required
                                            outlined></v-text-field>
                                        <v-text-field label="จำนวน (บาท)" type="number" v-model="account_input.price"
                                            :rules="[v => !!v || 'กรุณากรอกจำนวน']" required outlined></v-text-field>
                                        <v-textarea name="input-7-1" label="รายละเอียด"
                                            v-model="account_input.description" outlined>
                                            {{ account_input.description }}
                                        </v-textarea>
                                    </v-col>

                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                            <v-btn color="#28ab28" class="white--text" height="50" width="50%" type="submit">
                                บันทึก
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
            <!-- แก้ไข -->
            <v-dialog v-model="open_income_edit" persistent max-width="600px">
                <div v-if="loading_detail_page === true">
                    <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                    </v-sheet>
                </div>
                <v-card v-if="loading_detail_page === false">
                    <v-card-title class="title_open_title_in_account_day_list justify-space-between">
                        <div>
                            แก้ไขบันทึกเงินเข้า
                        </div>
                        <div class="cursor_open_title_in_account_day_list" @click="open_income_edit = false">
                            <v-icon color="white">mdi-close</v-icon>
                        </div>
                    </v-card-title>
                    <v-form ref="form_income_edit" @submit.prevent="addIncomeEdit()">
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <v-menu ref="menu_open_date_in_edit" v-model="menu_open_date_in_edit"
                                            :close-on-content-click="false" :return-value.sync="account_date_in_edit"
                                            transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="account_date_in_edit_be"
                                                    label="วันที่ (วัน/เดือน/ปี)" readonly v-bind="attrs" v-on="on"
                                                    :rules="[v => !!v || 'กรุณากรอกวันที่เริ่ม']" required
                                                    outlined></v-text-field>
                                            </template>
                                            <v-date-picker v-model="account_date_in_edit" :max="max_date" no-title
                                                scrollable locale="th" :events="dateStartEndBE('date_in_edit')">
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="searchDateEdit('date_in_edit')">
                                                    ตกลง
                                                </v-btn>
                                                <v-btn text color="primary" @click="menu_open_date_in_edit = false">
                                                    ยกเลิก
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                        <v-select label="ประเภทบัญชี" :items="account_type_in" @change="accountTypeIn"
                                            item-text="ac_type_name" item-value="id" v-model="account_input.ac_type_id"
                                            :rules="[v => !!v || 'กรุณาเลือกประเภทบัญชี']" required outlined>
                                        </v-select>
                                        <v-select label="รายชื่อเจ้าหนี้" v-if="creditor === 1"
                                            :items="account_creditor" item-text="creditor_name" item-value="id"
                                            v-model="account_input_creditor"
                                            :rules="[v => !!v || 'กรุณาเลือกรายชื่อเจ้าหนี้']" required outlined>
                                        </v-select>
                                        <v-select label="รายชื่อผู้ลงทุน" v-if="capital === 1" :items="account_capital"
                                            item-text="capital_name" item-value="id" v-model="account_input_capital"
                                            :rules="[v => !!v || 'กรุณาเลือกรายชื่อผู้ลงทุน']" required outlined>
                                        </v-select>
                                        <v-select label="รายชื่อเดลิเวอรี่" v-if="delivery === 1"
                                            :items="account_delivery" item-text="debtor_name" item-value="id"
                                            v-model="account_input_delivery"
                                            :rules="[v => !!v || 'กรุณาเลือกรายชื่อเดลิเวอรี่']" required outlined>
                                        </v-select>
                                        <v-select label="วันที่เดลิเวอรี่"
                                            v-if="account_input_delivery && status_accrued_income == 1"
                                            :items="account_date_delivery" item-text="date_create"
                                            item-value="account_books_id" v-model="account_input_date_delivery"
                                            :rules="[v => !!v || 'กรุณาเลือกรายชื่อเดลิเวอรี่']" required outlined>
                                        </v-select>
                                        <v-text-field label="ชื่อรายการ"
                                            v-if="creditor === 0 && capital === 0 && delivery === 0"
                                            v-model="account_input.ac_name" :rules="[v => !!v || 'กรุณากรอกชื่อรายการ']"
                                            required outlined></v-text-field>
                                        <v-text-field label="จำนวน (บาท)" type="number" v-model="account_input.price"
                                            :rules="[v => !!v || 'กรุณากรอกจำนวน']" required outlined></v-text-field>
                                        <v-textarea name="input-7-1" label="รายละเอียด"
                                            v-model="account_input.description" outlined>
                                        </v-textarea>
                                        <v-textarea name="input-7-1" label="เหตุผลในการแก้ไข" hide-details="auto"
                                            v-model="description_update"
                                            :rules="[v => !!v || 'กรุณากรอกเหตุผลในการแก้ไข']" required outlined>
                                        </v-textarea>
                                        <div class="mt-2 user_update_account_day_list">อัพเดทล่าสุดโดย : {{ user_update
                                            === null ||
                                            user_update === '' ? '-' : user_update }}</div>
                                    </v-col>

                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                            <v-btn color="#28ab28" class="white--text" height="50" width="50%" type="submit">
                                บันทึก
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
            <v-dialog v-model="open_outcome_edit" persistent max-width="600px">
                <div v-if="loading_detail_page === true">
                    <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                    </v-sheet>
                </div>
                <v-card v-if="loading_detail_page === false">
                    <v-card-title class="title_open_title_out_account_day_list justify-space-between">
                        <div>
                            แก้ไขบันทึกเงินออก
                        </div>
                        <div class="cursor_open_title_in_account_day_list" @click="open_outcome_edit = false">
                            <v-icon color="white">mdi-close</v-icon>
                        </div>
                    </v-card-title>
                    <v-form ref="form_outcome_edit" @submit.prevent="addOutcomeEdit()">
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <v-menu ref="menu_open_date_out_edit" v-model="menu_open_date_out_edit"
                                            :close-on-content-click="false" :return-value.sync="account_date_out_edit"
                                            transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="account_date_out_edit_be"
                                                    label="วันที่เริ่ม (วัน/เดือน/ปี)" readonly v-bind="attrs" v-on="on"
                                                    :rules="[v => !!v || 'กรุณากรอกวันที่เริ่ม']" required
                                                    outlined></v-text-field>
                                            </template>
                                            <v-date-picker v-model="account_date_out_edit" :max="max_date" no-title
                                                scrollable locale="th" :events="dateStartEndBE('date_out_edit')">
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="searchDateEdit('date_out_edit')">
                                                    ตกลง
                                                </v-btn>
                                                <v-btn text color="primary" @click="menu_open_date_out_edit = false">
                                                    ยกเลิก
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                        <v-select label="ประเภทบัญชี" :items="account_type_out" @change="accountTypeOut"
                                            item-text="ac_type_name" item-value="id" v-model="account_input.ac_type_id"
                                            :rules="[v => !!v || 'กรุณาเลือกประเภทบัญชี']" required outlined>
                                        </v-select>
                                        <v-select label="รายชื่อเจ้าหนี้" v-if="creditor === 1"
                                            :items="account_creditor" item-text="creditor_name" item-value="id"
                                            v-model="account_input_creditor"
                                            :rules="[v => !!v || 'กรุณาเลือกรายชื่อเจ้าหนี้']" required outlined>
                                        </v-select>
                                        <v-select label="รายชื่อผู้ลงทุน" v-if="capital === 1" :items="account_capital"
                                            item-text="capital_name" item-value="id" v-model="account_input_capital"
                                            :rules="[v => !!v || 'กรุณาเลือกรายชื่อผู้ลงทุน']" required outlined>
                                        </v-select>
                                        <v-select label="รายชื่อเดลิเวอรี่" v-if="delivery === 1"
                                            :items="account_delivery" item-text="debtor_name" item-value="id"
                                            v-model="account_input_delivery"
                                            :rules="[v => !!v || 'กรุณาเลือกรายชื่อเดลิเวอรี่']" required outlined>
                                        </v-select>
                                        <v-text-field label="ชื่อรายการ" v-model="account_input.ac_name"
                                            :rules="[v => !!v || 'กรุณากรอกชื่อรายการ']" required
                                            outlined></v-text-field>
                                        <v-text-field label="จำนวน (บาท)" type="number" v-model="account_input.price"
                                            :rules="[v => !!v || 'กรุณากรอกจำนวน']" required outlined></v-text-field>
                                        <v-textarea name="input-7-1" label="รายละเอียด"
                                            v-model="account_input.description" outlined>
                                        </v-textarea>
                                        <v-textarea name="input-7-1" label="เหตุผลในการแก้ไข" hide-details="auto"
                                            v-model="description_update"
                                            :rules="[v => !!v || 'กรุณากรอกเหตุผลในการแก้ไข']" required outlined>
                                        </v-textarea>
                                        <div class="mt-2 user_update_account_day_list">อัพเดทล่าสุดโดย : {{ user_update
                                            === null ||
                                            user_update === '' ? '-' : user_update }}</div>
                                    </v-col>

                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                            <v-btn color="#28ab28" class="white--text" height="50" width="50%" type="submit">
                                บันทึก
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
import accountrecord from '@/api/account/accountall/accountrecord.js';
import { currencyFormat } from "@/helper/numberformat.js";
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            loading_detail_page: true,
            alert_show_add: false,
            alert_show_edit: false,
            alert_show_error: false,
            message_error: '',
            page_number: 1,
            open_income: false,
            open_outcome: false,
            open_income_edit: false,
            open_outcome_edit: false,
            menu_open_date_in: false,
            menu_open_date_out: false,
            account_date_in_be: '',
            account_date_in: '',
            account_date_out_be: '',
            account_date_out: '',
            menu_open_date_in_edit: false,
            menu_open_date_out_edit: false,
            account_date_in_edit_be: '',
            account_date_in_edit: '',
            account_date_out_edit_be: '',
            account_date_out_edit: '',
            account_type_in: [],
            account_type_out: [],
            account_creditor: [],
            account_capital: [],
            account_delivery: [],
            account_date_delivery_list: [],
            account_date_delivery: [],
            status_accrued_income: 1,
            account_input: {
                ac_type_id: null,
                ac_name: null,
                price: null,
                description: null,
            },
            account_input_creditor: null,
            account_input_capital: null,
            account_input_delivery: null,
            account_input_date_delivery: null,
            creditor: 0,
            capital: 0,
            delivery: 0,
            edit_id: null,
            user_update: null,
            description_update: null,
            sortBy: 'number',
            sortDesc: true,
            sortIncomeBy: 'date_create',
            sortIncomeDesc: true,
            search: '',
            headers: [
                {
                    text: 'วันที่ทำรายการ',
                    align: 'date',
                    value: 'date_create',
                    sortable: true
                },
                {
                    text: 'รายการ',
                    value: 'ac_name'
                },
                {
                    text: 'ประเภทบัญชี',
                    value: 'ac_type'
                },
                {
                    text: 'เงินเข้า',
                    value: 'price_income'
                },
                {
                    text: 'เงินออก',
                    value: 'price_expenses'
                },
                {
                    text: 'คงเหลือ',
                    value: 'balance'
                },
                {
                    text: 'จัดการ',
                    value: 'action'
                },
            ],
            sortBy_accrued: 'number',
            sortDesc_accrued: true,
            search_accrued: '',
            headers_accrued: [
                {
                    text: 'วันที่ทำรายการ',
                    align: 'date',
                    value: 'number'
                },
                {
                    text: 'รายการ',
                    value: 'ac_name'
                },
                {
                    text: 'ประเภทบัญชี',
                    value: 'ac_type'
                },
                {
                    text: 'เงินเข้า',
                    value: 'price_income'
                },
            ],
            balance_all: 0,
            data: [],
        }
    },
    methods: {
        currencyFormat,
        async isNumberPrice(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async page(type) {
            this.loading_page = true
            this.page_number = type
            if (type === 1) {
                this.accountDayList()
            }
            if (type === 2) {
                this.accruedIncomeList()
            }
        },
        dateStartEndBE(type) {
            if (type == 'date_in') {
                if (this.account_date_in == '') {
                    this.account_date_in_be = ''
                }
                if (this.account_date_in) {
                    let date_arr = this.account_date_in.split('-')
                    let year = parseInt(date_arr[0]) + 543
                    let month = parseInt(date_arr[1]) - 1
                    month = this.$store.state.monthList[month].name_short
                    this.account_date_in_be = `${date_arr[2]}/${month}/${year}`
                }
            }
            if (type == 'date_out') {
                if (this.account_date_out == '') {
                    this.account_date_out_be = ''
                }
                if (this.account_date_out) {
                    let date_arr = this.account_date_out.split('-')
                    let year = parseInt(date_arr[0]) + 543
                    let month = parseInt(date_arr[1]) - 1
                    month = this.$store.state.monthList[month].name_short
                    this.account_date_out_be = `${date_arr[2]}/${month}/${year}`
                }
            }
            if (type == 'date_in_edit') {
                if (this.account_date_in_edit == '') {
                    this.account_date_in_edit_be = ''
                }
                if (this.account_date_in_edit) {
                    let date_arr = this.account_date_in_edit.split('-')
                    let year = parseInt(date_arr[0]) + 543
                    let month = parseInt(date_arr[1]) - 1
                    month = this.$store.state.monthList[month].name_short
                    this.account_date_in_edit_be = `${date_arr[2]}/${month}/${year}`
                }
            }
            if (type == 'date_out_edit') {
                if (this.account_date_out_edit == '') {
                    this.account_date_out_edit_be = ''
                }
                if (this.account_date_out_edit) {
                    let date_arr = this.account_date_out_edit.split('-')
                    let year = parseInt(date_arr[0]) + 543
                    let month = parseInt(date_arr[1]) - 1
                    month = this.$store.state.monthList[month].name_short
                    this.account_date_out_edit_be = `${date_arr[2]}/${month}/${year}`
                }
            }
        },
        async searchDate(type) {
            if (type == 'date_in') {
                this.$refs.menu_open_date_in.save(this.account_date_in)
                let date_arr = this.account_date_in.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.account_date_in_be = `${date_arr[2]}/${month}/${year}`
                this.menu_open_date_in = false
            }
            if (type == 'date_out') {
                this.$refs.menu_open_date_out.save(this.account_date_out)
                let date_arr = this.account_date_out.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.account_date_out_be = `${date_arr[2]}/${month}/${year}`
                this.menu_open_date_out = false
            }
        },
        async searchDateEdit(type) {
            if (type == 'date_in_edit') {
                this.$refs.menu_open_date_in_edit.save(this.account_date_in_edit)
                let date_arr = this.account_date_in_edit.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.account_date_in_edit_be = `${date_arr[2]}/${month}/${year}`
                this.menu_open_date_in_edit = false
            }
            if (type == 'date_out_edit') {
                this.$refs.menu_open_date_out_edit.save(this.account_date_out_edit)
                let date_arr = this.account_date_out_edit.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.account_date_out_edit_be = `${date_arr[2]}/${month}/${year}`
                this.menu_open_date_out_edit = false
            }

        },
        async accountDayList() {
            this.loading_page = true
            accountrecord.accountDayList().then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.acHistory
                    this.data.forEach((detail, index) => {
                        this.data[index]['number'] = index + 1
                        this.data[index]['price_income'] = detail.type == 1 ? '+ ' + detail.price : '-'
                        this.data[index]['price_expenses'] = detail.type == 0 ? '- ' + detail.price : '-'
                    })
                    // New
                    this.balance_all = response.data.balance_all
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async accruedIncomeList() {
            this.loading_page = true
            this.balance_all = 0
            accountrecord.accruedIncomeList().then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.acHistory
                    response.data.acHistory.forEach((detail, index) => {
                        this.data[index]['number'] = index + 1
                        this.data[index]['price_income'] = detail.type == 1 ? '+ ' + detail.price : '-'
                        this.data[index]['price_expenses'] = detail.type == 0 ? '- ' + detail.price : '-'
                    })
                    this.balance_all = response.data.balance_all
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async openIncome() {
            this.loading_detail_page = true
            this.open_income = true

            await accountrecord.creditorList().then((response) => {
                if (response.data.successful === true) {
                    this.account_creditor = response.data.creditor

                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
            await accountrecord.capitalList().then((response) => {
                if (response.data.successful === true) {
                    this.account_capital = response.data.capital

                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
            await accountrecord.foodDeliveryList().then((response) => {
                if (response.data.successful === true) {
                    this.account_delivery = response.data.deliver
                    this.account_date_delivery_list = response.data.acBooks
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
            await accountrecord.accountIncomeList().then((response) => {
                if (response.data.successful === true) {
                    this.account_type_in = response.data.acType
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            this.account_date_in = ''
            this.account_input = {
                ac_type_id: null,
                ac_name: null,
                price: null,
                description: null,
            }
            this.account_input_creditor = null
            this.account_input_capital = null
            this.account_input_delivery = null
            this.creditor = 0
            this.capital = 0
            this.delivery = 0
            this.user_updtae = null
            this.description_update = null
            this.loading_detail_page = false
        },
        async openOutcome() {
            this.loading_detail_page = true
            this.open_outcome = true

            await accountrecord.creditorList().then((response) => {
                if (response.data.successful === true) {
                    this.account_creditor = response.data.creditor

                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
            await accountrecord.capitalList().then((response) => {
                if (response.data.successful === true) {
                    this.account_capital = response.data.capital

                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
            await accountrecord.foodDeliveryList().then((response) => {
                if (response.data.successful === true) {
                    this.account_delivery = response.data.deliver

                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
            await accountrecord.accountExpensesList().then((response) => {
                if (response.data.successful === true) {
                    this.account_type_out = response.data.acType

                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            let getDateDefault = new Date().getDate() > 9 ? new Date().getDate().toString() : `0${new Date().getDate().toString()}`
            let getMonthDefault = new Date().getMonth() + 1
            if (getMonthDefault > 9) {
                getMonthDefault = getMonthDefault.toString()
            } else {
                getMonthDefault = `0${getMonthDefault.toString()}`
            }

            this.account_date_out = `${new Date().getFullYear()}-${getMonthDefault}-${getDateDefault}`
            this.account_input = {
                ac_type_id: null,
                ac_name: null,
                price: null,
                description: null,
            }
            this.account_input_creditor = null
            this.account_input_capital = null
            this.account_input_delivery = null
            this.creditor = 0
            this.capital = 0
            this.delivery = 0
            this.user_updtae = null
            this.description_update = null
            this.loading_detail_page = false
        },
        async accountTypeIn(id) {
            this.account_date_delivery = this.account_date_delivery_list
            this.account_input_creditor = null
            this.account_input_capital = null
            this.account_input_delivery = null

            this.creditor = 0
            this.capital = 0
            this.delivery = 0
            const account_typeIn = this.account_type_in.find((detail) => {
                return detail.id == id
            })
            if (account_typeIn.creditor) {
                this.creditor = 1
            }
            if (account_typeIn.capital) {
                this.capital = 1
            }
            if (account_typeIn.delivery) {
                this.delivery = 1
            }
            this.account_input.ac_name = null
        },
        async accountDateDelivery(id) {
            this.account_input_date_delivery = null
            this.account_date_delivery = this.account_date_delivery_list
            this.account_date_delivery = this.account_date_delivery.filter((detail) => {
                return detail.debtor_id == id
            })
        },
        async accountTypeOut(id) {
            this.account_input_creditor = null
            this.account_input_capital = null
            this.account_input_delivery = null
            this.creditor = 0
            this.capital = 0
            this.delivery = 0
            const account_typeOut = this.account_type_out.find((detail) => {
                return detail.id == id
            })
            if (account_typeOut.creditor) {
                this.creditor = 1
            }
            if (account_typeOut.capital) {
                this.capital = 1
            }
            if (account_typeOut.delivery) {
                this.delivery = 1
            }
            this.account_input.ac_name = null
        },
        async addIncome() {
            if (this.$refs.form_income.validate()) {
                this.message_error = ""
                this.open_income = false
                this.loading_page = true
                const data = {
                    date_create: this.account_date_in,
                    ac_type_id: this.account_input.ac_type_id,
                    ac_name: this.account_input.ac_name,
                    price: this.account_input.price,
                    description: this.account_input.description,
                    type: 1,
                }
                if (this.creditor === 1) {
                    data.creditor_id = this.account_input_creditor
                }
                if (this.capital === 1) {
                    data.capital_id = this.account_input_capital
                }
                if (this.delivery === 1) {
                    data.deliver_id = this.account_input_delivery
                }
                if (this.account_input_delivery) {
                    data.account_books_id = this.account_input_date_delivery
                }
                accountrecord.addAccountBook(data).then((response) => {
                    if (response.data.successful === true) {
                        this.loading_detail_page = false
                        this.open_income = false
                        this.loading_page = true
                        this.alert_show_add = true
                        setTimeout(() => this.alert_show_add = false, 5000)
                        this.accountDayList()
                    }
                    if (response.data.successful === false) {
                        this.message_error = response.data.message
                        this.loading_detail_page = false
                        this.alert_show_error = true
                        setTimeout(() => this.alert_show_error = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
        },
        async addOutcome() {
            if (this.$refs.form_outcome.validate()) {
                this.message_error = ""
                this.open_outcome = false
                this.loading_page = true
                const data = {
                    date_create: this.account_date_out,
                    ac_type_id: this.account_input.ac_type_id,
                    ac_name: this.account_input.ac_name,
                    price: this.account_input.price,
                    description: this.account_input.description,
                    type: 0,
                }
                if (this.creditor === 1) {
                    data.creditor_id = this.account_input_creditor
                }
                if (this.capital === 1) {
                    data.capital_id = this.account_input_capital
                }
                if (this.delivery === 1) {
                    data.deliver_id = this.account_input_delivery
                }
                accountrecord.addAccountBook(data).then((response) => {
                    if (response.data.successful === true) {
                        this.loading_detail_page = false
                        this.open_outcome = false
                        this.loading_page = true
                        this.alert_show_add = true
                        setTimeout(() => this.alert_show_add = false, 5000)
                        this.accountDayList()
                    }
                    if (response.data.successful === false) {
                        this.message_error = response.data.message
                        this.loading_detail_page = false
                        this.alert_show_error = true
                        setTimeout(() => this.alert_show_error = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
        },
        async addIncomeEdit() {
            if (this.$refs.form_income_edit.validate()) {
                this.message_error = ""
                this.open_income_edit = false
                this.loading_page = true
                const data = {
                    date_create: this.account_date_in,
                    ac_type_id: this.account_input.ac_type_id,
                    ac_name: this.account_input.ac_name,
                    price: this.account_input.price,
                    description: this.account_input.description,
                    type: 1,
                }
                if (this.creditor === 1) {
                    data.creditor_id = this.account_input_creditor
                }
                if (this.capital === 1) {
                    data.capital_id = this.account_input_capital
                }
                if (this.delivery === 1) {
                    data.deliver_id = this.account_input_delivery
                }
                if (this.account_input_delivery) {
                    data.account_books_id = this.account_input_date_delivery
                }
                accountrecord.editAccountBook(this.edit_id, data).then((response) => {
                    if (response.data.successful === true) {
                        this.loading_detail_page = false
                        this.open_income_edit = false
                        this.loading_page = true
                        this.alert_show_edit = true
                        setTimeout(() => this.alert_show_edit = false, 5000)
                        this.accountDayList()
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
        },
        async addOutcomeEdit() {
            if (this.$refs.form_outcome_edit.validate()) {
                this.open_outcome_edit = false
                this.loading_page = true
                const data = {
                    date_create: this.account_date_out,
                    ac_type_id: this.account_input.ac_type_id,
                    ac_name: this.account_input.ac_name,
                    price: this.account_input.price,
                    description: this.account_input.description,
                    type: 0,
                }
                if (this.creditor === 1) {
                    data.creditor_id = this.account_input_creditor
                }
                if (this.capital === 1) {
                    data.capital_id = this.account_input_capital
                }
                if (this.delivery === 1) {
                    data.deliver_id = this.account_input_delivery
                }
                data.description_update = this.description_update
                accountrecord.editAccountBook(this.edit_id, data).then((response) => {
                    if (response.data.successful === true) {
                        this.loading_detail_page = false
                        this.open_outcome_edit = false
                        this.loading_page = true
                        this.alert_show_edit = true
                        setTimeout(() => this.alert_show_edit = false, 5000)
                        this.accountDayList()
                    }
                    if (response.data.successful === false) {
                        this.message_error = response.data.message
                        this.loading_detail_page = false
                        this.alert_show_error = true
                        setTimeout(() => this.alert_show_error = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
        },
        async detailAccountBook(id, type) {
            this.loading_detail_page = true
            this.account_input_creditor = null
            this.account_input_capital = null
            this.account_input_delivery = null
            this.creditor = 0
            this.capital = 0
            this.delivery = 0
            if (type === 0) {
                this.open_outcome_edit = true
                await accountrecord.accountExpensesList().then((response) => {
                    if (response.data.successful === true) {
                        this.account_type_out = response.data.acType

                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
            if (type === 1) {
                this.open_income_edit = true
                await accountrecord.accountIncomeList().then((response) => {
                    if (response.data.successful === true) {
                        this.account_type_in = response.data.acType
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
            this.edit_id = id

            await accountrecord.creditorList().then((response) => {
                if (response.data.successful === true) {
                    this.account_creditor = response.data.creditor

                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
            await accountrecord.capitalList().then((response) => {
                if (response.data.successful === true) {
                    this.account_capital = response.data.capital

                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
            await accountrecord.foodDeliveryList().then((response) => {
                if (response.data.successful === true) {
                    this.account_delivery = response.data.deliver

                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            await accountrecord.detailAccountBook(id).then((response) => {
                if (response.data.successful === true) {
                    if (type === 0) {
                        this.account_date_out_edit = response.data.acBook.date_create
                    }
                    if (type === 1) {
                        this.account_date_in_edit = response.data.acBook.date_create
                    }
                    this.account_input = {
                        ac_type_id: response.data.acBook.ac_type_id,
                        ac_name: response.data.acBook.ac_name,
                        price: response.data.acBook.price,
                        description: response.data.acBook.description,
                    }
                    if (response.data.acBook.creditor_id !== null) {
                        this.creditor = 1
                        this.account_input_creditor = response.data.acBook.creditor_id
                    }
                    if (response.data.acBook.capital_id !== null) {
                        this.capital = 1
                        this.account_input_capital = response.data.acBook.capital_id
                    }
                    // if (response.data.acBook.delivery_id !== null) {
                    //     this.delivery = 1
                    //     this.account_input_delivery = response.data.acBook.delivery_id
                    // }
                    if (response.data.acBook.delivery_id !== null) {
                        this.delivery = 1
                        this.account_input_delivery = response.data.acBook.delivery_id
                        this.account_date_delivery = this.account_date_delivery_list
                        this.account_date_delivery = this.account_date_delivery.filter((detail) => {
                            return detail.debtor_id == response.data.acBook.debtor_id
                        })
                        this.account_input_date_delivery = response.data.acBook.account_books_id
                    }
                    this.user_update = response.data.acBook.user_update
                    this.description_update = response.data.acBook.description_update
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            this.loading_detail_page = false
        },
    },
    computed: {
        max_date() {
            const dateTodayList = new Date();
            let date_month = dateTodayList.getMonth() + 1
            if (date_month < 10) {
                date_month = '0' + date_month
            }
            let date_day = dateTodayList.getDate()
            if (date_day < 10) {
                date_day = '0' + date_day
            }
            const date_today = dateTodayList.getFullYear() + '-' + date_month + '-' + date_day
            return date_today
        }
    },
    mounted() {
        this.accountDayList()
    }
}
</script>

<style scoped>
.inout_account_day_list {
    display: grid;
    grid-template-columns: 50% 50%;
}

.img_inout_account_day_list {
    width: 50px;
}

.img_inout_account_day_list>img {
    max-width: 100%;
}

.title_open_title_in_account_day_list {
    background-color: #4caf50;
    color: #fff;
}

.title_open_title_out_account_day_list {
    background-color: #ff5252;
    color: #fff;
}

.cursor_open_title_in_account_day_list {
    cursor: pointer;
}
</style>
